import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { Grid, MenuItem, TextField, Button, Tooltip, ThemeProvider } from "@material-ui/core";
import { forwardRef } from "react";
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import * as FileSaver from 'file-saver';
import Alert from '@material-ui/lab/Alert';
//import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from "react-redux";
//import DialogContent from '@material-ui/core/DialogContent';
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";
export const tableIconsInputScreen = {
    Add: forwardRef((props, ref) => <AddBox  {...props} ref={ref} />),
    Check: forwardRef((props, ref) => (
        <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Clear: forwardRef((props, ref) => (
        <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
        <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
const api_historyFilter = axios.create({
    baseURL: 'InventoryAudit'
})
export const DownloadHistory = (props) => {
   // console.log("issueresolved", props.selectedD);
   // console.log("doanloadhistoryProps", props)
    const [checkedV, setcheckedV] = useState(props.historyData1);
    const [errorMessages, setErrorMessages] = useState([]);
   // const [workFlowD, setWorkFlowD] = useState();
   // const [plantD, setPlantD] = useState();

    
   // const [initialCheckedTbValue, setInitialCheckedTbValue] = useState(mData);
   
    
    const clear = () => {
        console.log("clear");
    }
    const [openLoader, setopenLoader] = useState(false);
    const [locDownload, setLocDownload] = useState();
    const [iserror, setIserror] = useState(false);
    const [severity, setSeverity] = useState('success');
   /* const [openLoader, setopenLoader] = useState(false);*/
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
     (state) => state.storeUserDetailsReducer.userData
   );
    const bearerToken = useSelector(
     (state) => state.saveBearerTokenReducer.bearerToken
   );
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }  
    const handleErrorClose = (e) => {
        setIserror(false);
    }
    
    const [flocRep, setFlocRep] = useState("");
    function getLocReport(PlantName, Workflow) {
        setopenLoader(true);
        const options = {
            method: "get",
            responseType: "arraybuffer",
            headers: {  
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId },
            //params: { poentryid: poentryid },
            params: { PlantName: PlantName, Workflow: Workflow },

        };
        return axios
            .get(
                "/InventoryAudit/DownloadLocationwiseReport",
                options
            )
            .then((response) => {
                setopenLoader(false);
                //setFlocRep(response);
                return response;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });



    }
   
   

    

    
    async function downloadLocData() {
            setopenLoader(true);
            let response = [];
            let errorList = [];
            //props.selectedRows1.filter(x => x.tableData.checked == true);
            //let xyz = checkedV.filter((x) => x.tableData.checked == true);
        let xyz = checkedV.filter((x) => x.tableData.id == props.mData);
          //  console.log("jspage", xyz);


            let plantD = xyz.map((x) => x.plantName);
            let workFlowD = xyz.map((x) => x.workflow);

            //console.log("plantD", plantD[0]);
           // console.log("workFlowD", workFlowD[0]);



            let data = {
                Workflow: workFlowD[0],
                PlantName: plantD[0],


            }

            let isValidate = true;
            

       
           
            getLocReport(plantD[0], workFlowD[0])
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.byteLength <= 200) {
                        setopenLoader(false);
                        errorList.push("No Records are Found");

                        showMessage(errorList, true, 'error');
                        //alert("data is wrong");
                        //back();
                        //setIsLoader(false);

                        //handleSnackOpen();

                        //setSnackMessage("No Records are Found ");

                        //setAlertType("success");

                    } else {
                        setopenLoader(false);

                        var blob = new Blob([response.data], {

                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

                        });

                        FileSaver.saveAs(blob, "LocationwiseReport.xlsx");

                        //setIsLoader(false);

                       // handleSnackOpen();

                        //setSnackMessage("Report Downloaded");

                        //setAlertType("success");

                    }

                } else {
                    console.log("*");
                    //setIsLoader(false);

                   // handleSnackOpen();

                    //setSnackMessage("Report download failed");

                    //setAlertType("error");

                }

            })

            .catch((error) => {

                ///setIsLoader(false);

                //handleSnackOpen();

               // setSnackMessage("Error: ", error);

                //setAlertType("error");

            });

    }
   
    ///DownloadMaterialwiseReport 
    const [fMaterialRep, setFMaterialRep] = useState("");
    function getMaterialReport(PlantName, Workflow) {
        const options = {
            method: "get",
            responseType: "arraybuffer",
            headers: {  
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId},
            //params: { poentryid: poentryid },
            params: { PlantName: PlantName, Workflow: Workflow },

        };
        return axios
            .get(
                "/InventoryAudit/DownloadMaterialwiseReport",
                options
            )
            .then((response) => {
                //setFlocRep(response);
                return response;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });



    }

    async function downloadMaterialData() {
        setopenLoader(true);
        let response = [];
        let errorList = [];
        //props.selectedRows1.filter(x => x.tableData.checked == true);
        //let xyz = checkedV.filter((x) => x.tableData.checked == true);
        let xyz = checkedV.filter((x) => x.tableData.id == props.mData);
      //  console.log("jspage", xyz);


        let plantD = xyz.map((x) => x.plantName);
        let workFlowD = xyz.map((x) => x.workflow);

       // console.log("plantD", plantD[0]);
       // console.log("workFlowD", workFlowD[0]);



        let data = {
            Workflow: workFlowD[0],
            PlantName: plantD[0],


        }

        let isValidate = true;


        //setIsLoader(true);

        //GetQuotationReport(token)
        ///getLocReport()
        getMaterialReport(plantD[0], workFlowD[0])
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.byteLength <= 200) {
                        setopenLoader(false);
                        errorList.push("No Records are Found");
                        showMessage(errorList, true, 'error');
                        //alert("no records are found");
                        //setIsLoader(false);

                        //handleSnackOpen();

                        //setSnackMessage("No Records are Found ");

                        //setAlertType("success");

                    } else {
                        setopenLoader(false);
                        var blob = new Blob([response.data], {

                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

                        });

                        FileSaver.saveAs(blob, "MaterialwiseReport.xlsx"); //need to changes

                        //setIsLoader(false);

                        // handleSnackOpen();

                        //setSnackMessage("Report Downloaded");

                        //setAlertType("success");

                    }

                } else {
                    console.log("*");
                    //setIsLoader(false);

                    // handleSnackOpen();

                    //setSnackMessage("Report download failed");

                    //setAlertType("error");

                }

            })

            .catch((error) => {

                ///setIsLoader(false);

                //handleSnackOpen();

                // setSnackMessage("Error: ", error);

                //setAlertType("error");

            });

    }
    //DownloadMRPControllerwiseReport
    const [fMRPCRep, setFMRPCRep] = useState("");
    function getMRPControllerReport(PlantName, Workflow) {
        const options = {
            method: "get",
            responseType: "arraybuffer",
            headers: {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId, },
            //params: { poentryid: poentryid },
            params: { PlantName: PlantName, Workflow: Workflow },

        };
        return axios
            .get(
                "/InventoryAudit/DownloadMRPControllerwiseReport",
                options
            )
            .then((response) => {
                //setFlocRep(response);
                return response;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });



    }

    async function downloadMRPControllerData() {
        setopenLoader(true);
        let response = [];
        let errorList = [];
        //props.selectedRows1.filter(x => x.tableData.checked == true);
        //let xyz = checkedV.filter((x) => x.tableData.checked == true);
        let xyz = checkedV.filter((x) => x.tableData.id == props.mData);
       // console.log("jspage", xyz);


        let plantD = xyz.map((x) => x.plantName);
        let workFlowD = xyz.map((x) => x.workflow);

       // console.log("plantD", plantD[0]);
       // console.log("workFlowD", workFlowD[0]);



        let data = {
            Workflow: workFlowD[0],
            PlantName: plantD[0],


        }

        let isValidate = true;


        //setIsLoader(true);

        //GetQuotationReport(token)
        ///getLocReport()
        getMRPControllerReport(plantD[0], workFlowD[0])
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.byteLength <= 200) {
                        setopenLoader(false);
                        errorList.push("No Records are Found");
                        showMessage(errorList, true, 'error');
                       // alert("no records are found");
                        //setIsLoader(false);

                        //handleSnackOpen();

                        //setSnackMessage("No Records are Found ");

                        //setAlertType("success");

                    } else {
                        setopenLoader(false);
                        var blob = new Blob([response.data], {

                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

                        });

                        FileSaver.saveAs(blob, "MRPControllerwiseReport.xlsx"); //need to changes

                        //setIsLoader(false);

                        // handleSnackOpen();

                        //setSnackMessage("Report Downloaded");

                        //setAlertType("success");

                    }

                } else {
                    console.log("*");
                    //setIsLoader(false);

                    // handleSnackOpen();

                    //setSnackMessage("Report download failed");

                    //setAlertType("error");

                }

            })

            .catch((error) => {

                ///setIsLoader(false);

                //handleSnackOpen();

                // setSnackMessage("Error: ", error);

                //setAlertType("error");

            });

    }
    ///DownloadSlipwiseReport
    const [fSlipwiseReportRep, setFSlipwiseReportRep] = useState("");
    function getSlipwiseReport(PlantName, Workflow) {
        const options = {
            method: "get",
            responseType: "arraybuffer",
            headers: {  
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId },
            //params: { poentryid: poentryid },
            params: { PlantName: PlantName, Workflow: Workflow },

        };
        return axios
            .get(
                "/InventoryAudit/DownloadSlipwiseReport",
                options
            )
            .then((response) => {
                //setFlocRep(response);
                return response;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });



    }

    async function downloadSlipData() {
        setopenLoader(true);
        let response = [];
        let errorList = [];
        //props.selectedRows1.filter(x => x.tableData.checked == true);
        //let xyz = checkedV.filter((x) => x.tableData.checked == true);
        let xyz = checkedV.filter((x) => x.tableData.id == props.mData);
       // console.log("jspage", xyz);


        let plantD = xyz.map((x) => x.plantName);
        let workFlowD = xyz.map((x) => x.workflow);

      //  console.log("plantD", plantD[0]);
      //  console.log("workFlowD", workFlowD[0]);



        let data = {
            Workflow: workFlowD[0],
            PlantName: plantD[0],


        }

        let isValidate = true;


        //setIsLoader(true);

        //GetQuotationReport(token)
        ///getLocReport()
        setopenLoader(true);
        getSlipwiseReport(plantD[0], workFlowD[0])   
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.byteLength <= 200) {
                        //alert("no records are found");
                        //setIsLoader(false);

                        //handleSnackOpen();

                        //setSnackMessage("No Records are Found ");

                        //setAlertType("success");
                        setopenLoader(false);
                        errorList.push("No Records are Found");
                        showMessage(errorList, true, 'error');

                    } else {
                        setopenLoader(false);
                        var blob = new Blob([response.data], {

                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

                        });

                        FileSaver.saveAs(blob, "Slips.xlsx"); //need to changes

                        //setIsLoader(false);

                        // handleSnackOpen();

                        //setSnackMessage("Report Downloaded");

                        //setAlertType("success");

                    }

                } else {
                    console.log("*");
                    //setIsLoader(false);

                    // handleSnackOpen();

                    //setSnackMessage("Report download failed");

                    //setAlertType("error");

                }

            })

            .catch((error) => {

                ///setIsLoader(false);

                //handleSnackOpen();

                // setSnackMessage("Error: ", error);

                //setAlertType("error");

            });

    }
    //DownloadAuditSlipwiseReport

    const [fAuditSlipRep, setFAuditSlipRep] = useState("");
    function getAuditSlipReport(PlantName, Workflow) {
        
        const options = {
            method: "get",
            responseType: "arraybuffer",
            headers: {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId},
            //params: { poentryid: poentryid },
            params: { PlantName: PlantName, Workflow: Workflow },

        };
        return axios
            .get(
                "/InventoryAudit/DownloadAuditSlipwiseReport",
                options
            )
            .then((response) => {
                //setFlocRep(response);
                return response;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });



    }

  
  

    async function downloadAuditSlipData() {
        setopenLoader(true);
        let response = [];
        let errorList = [];
        //props.selectedRows1.filter(x => x.tableData.checked == true);
        //let xyz = checkedV.filter((x) => x.tableData.checked == true);
        let xyz = checkedV.filter((x) => x.tableData.id == props.mData);
       // console.log("jspage", xyz);


        let plantD = xyz.map((x) => x.plantName);
        let workFlowD = xyz.map((x) => x.workflow);

       // console.log("plantD", plantD[0]);
      //  console.log("workFlowD", workFlowD[0]);



        let data = {
            Workflow: workFlowD[0],
            PlantName: plantD[0],


        }

        let isValidate = true;


        //setIsLoader(true);

        //GetQuotationReport(token)
        ///getLocReport()
        getAuditSlipReport(plantD[0], workFlowD[0])
            .then((response) => {

                if (response.status === 200) {

                    if (response.data.byteLength <= 200) {
                        setopenLoader(false);
                        errorList.push("No Records are Found");

                        showMessage(errorList, true, 'error');
                       // alert("no records are found");
                        //setIsLoader(false);

                        //handleSnackOpen();

                        //setSnackMessage("No Records are Found ");

                        //setAlertType("success");

                    } else {
                        setopenLoader(false);
                        var blob = new Blob([response.data], {

                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

                        });

                        FileSaver.saveAs(blob, "AuditSlips.xlsx"); //need to changes

                        //setIsLoader(false);

                        // handleSnackOpen();

                        //setSnackMessage("Report Downloaded");

                        //setAlertType("success");

                    }

                } else {
                    console.log("*");
                    //setIsLoader(false);

                    // handleSnackOpen();

                    //setSnackMessage("Report download failed");

                    //setAlertType("error");

                }

            })

            .catch((error) => {

                ///setIsLoader(false);

                //handleSnackOpen();

                // setSnackMessage("Error: ", error);

                //setAlertType("error");

            });

    }
        
     

    const back = () => {
        
        //let result = props.selectedRows1.filter(x => x.tableData.checked == true);
        //if (result) {
            
        //    result.map((y) => props.setmData(y.tableData.checked = false));
        //}
        props.setOpenModalDownloadD(false);
    }
   
   
    return (
        <div >
           
            <Dialog
                open={props.openModalDownloadD}
                disableBackdropClick
                maxWidth={"lg"}
                aria-labelledby="edit-dialog-title"
                onClose={() => { props.setCloseModalDownloadD(true) }}
              
        >
                <DialogContent >
                 <div >
                        <h4> You can download data here!!</h4>
                        <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                            <div>
                                {iserror &&
                                    <Alert severity={severity} onClose={handleErrorClose}>
                                        {errorMessages.map((msg, i) => {
                                            return <div key={i}>{msg}</div>
                                        })}
                                    </Alert>
                                }
                            </div>
                        </Grid>
                    <div className="download-popup" >
                        <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                <Button className="ns-btn-download mt-1 mr-1" onClick={downloadMRPControllerData} >
                                <span>Download MRP Controller Wise Report</span>
                            </Button>
                        </div>
                        <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                <Button className="ns-btn-download mt-1 mr-1" onClick={downloadLocData} >
                                <span>Download Location wise report</span>
                            </Button>
                        </div>
                            <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                <Button className="ns-btn-download mt-1 mr-1" onClick={downloadMaterialData} >
                                    <span>Download Material wise report </span>
                                </Button>
                            </div>

                            <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                <Button className="ns-btn-download mt-1 mr-1" onClick={downloadSlipData} >
                                    <span>Download Slips</span>
                                </Button>
                            </div>

                            <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                <Button className="ns-btn-download mt-1 mr-1" onClick={downloadAuditSlipData} >
                                    <span>Download Audit Slips</span>
                                </Button>
                            </div>

                            <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                <Button className="ns-btn-download mt-1 mr-1" onClick={back} >
                                    <span>Back</span>
                                </Button>
                            </div>

                           

                           
                            
                    </div>

                </div>


            </DialogContent>
            </Dialog>
            <Dialog
                open={openLoader}
                //onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                id="templateUploadSuccess"
                PaperProps={{
                    style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        borderColor: "transparent"
                    },
                }}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </div>
       
        );
}